import { AuthService } from './Auth/service/auth.service';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private _AuthService:AuthService , private _Router:Router)
  {

  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      if(this._AuthService.currentUser.getValue() != null)
      {
        return true ;
      }
      if(localStorage.getItem('token')) {
        this._AuthService.saveCurrentUser();
        if(this._AuthService.currentUser.getValue() != null) {
          return true;
        }
      }
      // this._Router.navigate(['/login']); // <-- Disable redirect for debugging
      return false ;
  }
  
}
